// extracted by mini-css-extract-plugin
export default {"editor":"AvaChanger-module__editor--EX-z4","range":"AvaChanger-module__range--ro8ge","buttons":"AvaChanger-module__buttons--n8aN6"};